module.exports = __webpack_public_path__ + "img/up_b.359b3b36.png";